import { Box, Container, type ContainerProps, Stack, Typography } from '@mui/material'
import type { ComponentChildren } from 'preact'

/** Layout of a page of the organizer space: title, optional actions, content. */
export function SectionPage({
  title,
  overline,
  actions,
  maxWidth = 'md',
  children,
}: {
  title: string
  overline?: string
  actions?: ComponentChildren
  maxWidth?: ContainerProps['maxWidth']
  children: ComponentChildren
}) {
  return (
    <Container maxWidth={maxWidth} sx={{ py: { xs: 2, md: 4 } }}>
      <Stack
        direction="row"
        sx={{
          alignItems: 'flex-end',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: 2,
          mb: 3,
        }}
      >
        <Box>
          {overline && (
            <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
              {overline}
            </Typography>
          )}
          <Typography variant="h4" component="h1" sx={{ fontSize: { xs: 26, md: 30 } }}>
            {title}
          </Typography>
        </Box>
        {actions && (
          <Stack direction="row" sx={{ flexWrap: 'wrap', gap: 1.25 }}>
            {actions}
          </Stack>
        )}
      </Stack>
      {children}
    </Container>
  )
}
